export const REQUEST_STARTED = "REQUEST_STARTED";
export const REQUEST_FAIL = "REQUEST_FAIL";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FINISHED = "REQUEST_FINISHED";

export const CLEAR_REQUEST_INFO = "CLEAR_REQUEST_INFO";
